export class SchoolUserTypeDetail {
  schoolId: number;
  programIds: number[] = [];
  userTypeId: number;
  userType: string;
  userTypeEn: string;
  isDefault: boolean;
}

export class SchoolUserTypeModel {
  schoolId: number;
  schoolName?: string;
  schoolNameEn?: string;
  userTypesIds: number[] = [];
}
